module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3683e23b8be8e893db34f3430d3c0595.png";